export const AUSTRALIAN_CITIES = [
    'Adelaide',
    'Brisbane',
    'Canberra',
    'Darwin',
    'Hobart',
    'Melbourne',
    'Perth',
    'Sydney',
    'Australia-Wide',
];
